import { SelectOption } from 'components/form-inputs/select-option/select-option';
import { isArray, isString, map } from 'lodash';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { OfferResponse } from './api-models';
import { TutoringType } from './tutoring-type';

export const isTutoringTypeEnabled = <T>(
  tutoringTypes: (T | undefined)[] | undefined,
  tutoringType: T | undefined
) =>
  (tutoringType &&
    !isString(tutoringTypes) &&
    isArray(tutoringTypes) &&
    tutoringTypes?.includes(tutoringType)) ||
  false;

export const getEnabledTutoringTypes = (tutoringType: OfferResponse['tutoringType']) =>
  map(tutoringType).filter((teachingLocation) =>
    isTutoringTypeEnabled(tutoringType, teachingLocation)
  );

type TutoringTypeSelectOptions = SelectOption<TutoringType, string>;

export const getInstituteTutoringTypeSelectOptions: () => TutoringTypeSelectOptions[] = () =>
  map(TutoringType).map((tutoringType) => ({
    value: tutoringType,
    label: translate(translationKeys.common.instituteTeachingLocation[tutoringType]),
  }));

export const getTutoringTypeSelectOptions: () => TutoringTypeSelectOptions[] = () =>
  map(TutoringType).map((tutoringType) => ({
    value: tutoringType,
    label: translate(translationKeys.common.teachingLocation[tutoringType]),
  }));
